<template>
  <div
    v-if="isVisible"
    class="absolute inset-0 z-50 bg-white dark:bg-gray-900 bg-opacity-95 dark:bg-opacity-95 flex items-center justify-center"
  >
    <LoadingSpinner 
      size="lg" 
      color="primary" 
      text="Cargando orden para edición..."
    >
      <template #default>
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Por favor espera un momento
        </p>
      </template>
    </LoadingSpinner>
  </div>
</template>

<script setup lang="ts">
import LoadingSpinner from '@/components/base/LoadingSpinner.vue'

interface Props {
  isVisible: boolean
}

defineProps<Props>()
</script>
